import LocalSettingsProtoDepricated from "../../gd/settings/local-settings/local-settings-v3"

// Keeps all local settings for a project
export default class ProjectCollectionLocalSettings extends LocalSettingsProtoDepricated {

    public views        : any = {}
    public defaultView  : any

    constructor(projectCollectionId: ID) {
        super("project-collection." + projectCollectionId)

        const lsValues = this._readFromLocalStorage()

        this.normalize(lsValues)
    }

    deleteView(projectViewId: ID) {
        if (this.views[projectViewId]) {
            delete this.views[projectViewId]
        }
        this.save()
    }

    // reset (null) appSettings for current view in local setting
    resetViewAppSettings(viewId: ID) {
        if (this.views[viewId]) {
            //reset appSettings
            const viewSettings = this.views[viewId].appSettings = null
            this.save();
        }
    }

    normalize(values: any) {
        this.views          = _.get(values, 'views', {})
        this.defaultView    = _.get(values, 'defaultView', null)
    }

    toObject() {
        return {
            views       : this.views,
            defaultView : this.defaultView
        }
    }
}
